<template>
	<div class="DeepseekRemoteDeploy">
		<div class="text-center" v-if="showTitle">
			<div class="fs-1 w-700 deploy-title">{{ mainTitle }}</div>
			<div class="fs-3 deploy-subtitle">{{ subTitle }}</div>
		</div>
		<div class="DeepseekRemoteDeploycontion container">
			<!-- 标题部分 -->
			<div class="service-description">
				为大模型企业落地Plus服务，全方位助力企业实现大模型技术的深度应用。提供涵盖
				<span
					class="highlight-services">大模型咨询、模型共创、部署陪跑、内部培训以及联合实验室建设</span>等多元服务，为企业量身打造从技术选型到落地实施的一站式解决方案，加速企业智能化转型进程。
			</div>

			<!-- 部署模式卡片 -->
			<div class="deploy-cards-container">
				<div v-for="(card, index) in deployData.cards" :key="index" class="deploy-card"
					:class="`card-${index + 1}`" data-aos="fade-up" :data-aos-delay="index * 100"
					@mouseenter="onCardHover(index)" @mouseleave="onCardLeave(index)">
					<!-- 卡片头部 -->
					<div class="card-header" :class="card.headerClass">
						<div class="card-title">{{ card.title }}</div>
						<p class="card-subtitle">{{ card.subtitle }}</p>
					</div>

					<!-- 卡片内容 -->
					<div class="card-content">
						<div class="card-main-title">{{ card.mainTitle }}</div>
						<ul class="card-features">
							<li v-for="(feature, fIndex) in card.features" :key="fIndex" class="feature-item">
								<div class="feature-icon-wrapper">
									<img src="@/assets/images/dataAgent/对号-初始_icon_svg.svg" alt="check icon"
										class="feature-icon default-icon" />
									<img src="@/assets/images/dataAgent/对号-悬浮_icon_svg.svg" alt="check icon hover"
										class="feature-icon hover-icon" />
								</div>
								<span>{{ feature }}</span>
							</li>
						</ul>
					</div>

					<!-- 悬浮效果层 -->
					<div class="card-hover-overlay"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'DeepseekRemoteDeploy',
		props: {
			// 原有的props
			showTitle: {
				type: Boolean,
				default: false
			},
			mainTitle: {
				type: String,
				default: ''
			},
			subTitle: {
				type: String,
				default: ''
			},
			// 新增的部署数据props
			deployData: {
				type: Object,
				required: true,
				default: () => ({
					title: 'Deepseek+企业级AI元生平台，多样化的应用部署模式',
					subtitle: '满足业务特性，成就企业梦想',
					description: '为大型企业提供灵活多样的部署方案',
					cards: []
				})
			}
		},
		data() {
			return {
				hoveredCard: null
			}
		},
		mounted() {},
		methods: {
			onCardHover(index) {
				this.hoveredCard = index;
			},
			onCardLeave(index) {
				this.hoveredCard = null;
			}
		}
	}
</script>

<style scoped>
	/* 保持之前提供的所有CSS样式 */
	.DeepseekRemoteDeploy {
		padding: 52px 0 109px 0;
		background: #fff;
		/* height: 700px; */
	}

	.service-description {
		color: #354a6e;
		font-face: PingFangSC;
		font-weight: 400;
		line-height: 28px;
		letter-spacing: 0;
		paragraph-spacing: 0;
		text-align: center;
	}

	.highlight-services {
		color: #005bab;
	}

	.headertitl {
		color: #12294F;
	}

	/* 标题部分动画 */
	.deploy-header {
		text-align: center;
		margin-bottom: 60px;
		padding: 0 20px;
	}

	.fade-in-up {
		animation: fadeInUp 1s ease-out;
	}

	@keyframes fadeInUp {
		from {
			opacity: 0;
			transform: translateY(30px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.deploy-title {
		font-weight: 700;
		margin-bottom: 16px;
		line-height: 1.2;
		font-family: PingFangSC-Semibold;
		font-weight: 600;
		color: #12294F;
	}

	.deploy-subtitle {
		margin-bottom: 20px;
		font-family: PingFangSC-Regular;
		font-weight: 400;
		color: #5F6C81;
		text-align: center;
		line-height: 28px;
	}

	.deploy-description {
		font-size: 1rem;
		color: #5a6c7d;
		line-height: 1.8;
		max-width: 800px;
		margin: 0 auto;
	}

	/* 卡片容器 */
	.deploy-cards-container {
		margin-top: 68px;
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
		gap: 30px;
	}

	/* 卡片基础样式 */
	.deploy-card {
		width: 368px;
		position: relative;
		background: white;
		border-radius: 8px;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
		overflow: hidden;
		cursor: pointer;
		border: 2px solid transparent;
		/* 初始设为透明边框 */
		transition:
			border-color 0.5s ease;
		/* 只保留边框颜色的过渡，时间延长到0.5秒 */
	}

	/* 鼠标悬浮效果 */
	.deploy-card:hover {
		border-color: #005BAB;
		box-shadow: 0 8px 25px rgba(0, 91, 171, 0.15);
	}

	/* 卡片头部基础样式 */
	.card-header {
		padding: 20px 24px;
		box-sizing: border-box;
		height: 90px;
		overflow: hidden;
		background-image: url('../../assets/images/dataAgent/头部背景底纹_image@2x.png');
		background-size: cover;
		background-position: center center;
		background-repeat: no-repeat;
	}

	/* 卡片内容基础样式 */
	.card-content {
		padding: 24px;
		background-image: linear-gradient(-51deg, #005bab0a 0%, #0088cc00 94%);

		border-radius: 8px;
	}
	.card-features{
		padding: 0 !important;
	}
	/* 特征项基础样式 */
	.feature-item {
		display: flex;
		align-items: center;
		padding: 10px 0;
		font-size: 1.4rem;
		border-radius: 8px;
		margin: 2px 0;
		font-family: AlibabaPuHuiTi_2_55_Regular;
		font-weight: 400;
		color: #485D80;
		letter-spacing: 0;
		line-height: 26px;
	}

	/* 图标容器 */
	.feature-icon-wrapper {
		position: relative;
		width: 12px;
		height: 12px;
		margin-right: 12px;
		flex-shrink: 0;
	}

	/* 图标基础样式 */
	.feature-icon {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		transition: opacity 0.3s ease;
	}

	/* 默认图标显示，悬浮图标隐藏 */
	.feature-icon.default-icon {
		opacity: 1;
	}

	.feature-icon.hover-icon {
		opacity: 0;
	}

	/* 卡片悬浮时切换图标 */
	.deploy-card:hover .feature-icon.default-icon {
		opacity: 0;
	}

	.deploy-card:hover .feature-icon.hover-icon {
		opacity: 1;
	}

	/* 特征项文本样式 */
	.feature-item span {
		line-height: 1.4;
	}

	/* 卡片标题基础样式 */
	.card-title {
		font-size: 1.6rem;
		font-family: Alibaba-PuHuiTi-B;
		font-weight: 900;
		color: #FFFFFF;
		letter-spacing: 0;
	}

	.card-subtitle {
		font-size: 1.4rem;
		font-family: AlibabaPuHuiTi_2_55_Regular;
		font-weight: 400;
		color: #C6E2FA;
		letter-spacing: 0;
	}

	/* 主标题基础样式 */
	.card-main-title {
		font-size: 1.6rem;
		font-family: Alibaba-PuHuiTi-B;
		font-weight: bold;
		color: #07274A;
	}


	/* 响应式设计 */
	@media (max-width: 768px) {
		.deploy-cards-container {
			grid-template-columns: 1fr;
			gap: 20px;
			padding: 0 16px;
		}

		.card-header {
			padding: 20px 20px 12px;
		}

		.card-content {
			padding: 20px;
		}

		.card-title {
			font-size: 1.2rem;
		}
	}
</style>